//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.ShipDesign.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Expression.js";
import "../GeometricUtilities/GeometricUtilities.OnPathDimensionBuilder.js";
import "../no/Section.js";
import "../no/SelectTaggedObject.js";
import "../no/SelectTaggedObjectList.js";
import "../Features/Features.ShipDesign.SteelFeatureSpreadsheetBuilder.js";
import "../no/Expression.js";
import "../no/GeometricUtilities.js";
import "../no/Section.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
import "../no/Features.js";
let d=[[[1,"AngularDimOffset",0,"Expression",0],[0,"EnumSpacing",1,0],[1,"GuideOffset",0,"Expression",0],[0,"IntNumVents",1,0],[1,"OnPathEndOffset",0,"GeometricUtilities.OnPathDimensionBuilder",0],[1,"OnPathStartOffset",0,"GeometricUtilities.OnPathDimensionBuilder",0],[1,"SectionGuide",0,"Section",0],[1,"SelectEndTrim",0,"SelectTaggedObject",0],[1,"SelectStartTrim",0,"SelectTaggedObject",0],[1,"SelectTargetFace",0,"SelectTaggedObjectList",0],[1,"SketchBlock",0,"Features.ShipDesign.SteelFeatureSpreadsheetBuilder",0],[0,"ToggleSymmetricOffsets",1,0],[1,"VentSpacing",0,"Expression",0]],[],[]];
SPLM.Features.ShipDesign.VentilationHoles2Builder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ShipDesign.VentilationHoles2Builder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.ShipDesign.VentilationHoles2Builder.ArraySpacing = Object.freeze({
    "EvenDistribution" : "EvenDistribution", "CustomDefined" : "CustomDefined"});

export default SPLM;